import React from "react";
import { useSelector } from "react-redux";
import MaterialTooltip from "@material-ui/core/Tooltip";
import { IAdvertisersByCompany } from "../../../../types/stores/vars";
import { IAppState } from "../../../../types/stores";
import { Icon } from "@material-ui/core";

type ExportDestinationSquareProps = {
    flowItemId: number;
    selectedDestinationId: number | undefined;
    destination: IAdvertisersByCompany;
    onClick: (destinationId: number) => void;
    disabled?: boolean; // visually disabled (mixed 3P + Experian without TrackingID)
};

const ExportDestinationSquare: React.FC<ExportDestinationSquareProps> = ({
    flowItemId,
    selectedDestinationId,
    destination,
    onClick,
    disabled = false,
}) => {
    const isInternal = useSelector((state: IAppState) => state.session.isInternal);
    const title =
        destination.VerticalName +
        " - " +
        destination.CompanyName +
        (isInternal && destination.FTPFolder != null ? " (" + destination.FTPFolder + ")" : "");
    const selected = destination.PartnerAccessId == selectedDestinationId;
    const tooltip = disabled
        ? "Unavailable for mixed 3P + Experian (TrackingID required). Click to request access."
        : selected
          ? "Click to select another destination."
          : "Click to select this destination.";

    return (
        <div id={"li_" + flowItemId + "_" + destination.PartnerAccessId}>
            <MaterialTooltip title={tooltip}>
                <div
                    className="singleview-square"
                    onClick={() => onClick(destination.PartnerAccessId)}
                    style={
                        disabled
                            ? {
                                  opacity: 0.5,
                                  filter: "grayscale(80%)",
                                  border: "1px dashed #bbb",
                              }
                            : undefined
                    }
                >
                    <div className="singleview-logo">
                        <img
                            src={"/Images/CompanyLogo/" + destination.PartnerAccessId}
                            alt={destination.CompanyName}
                            title=""
                            style={disabled ? { filter: "grayscale(100%)" } : undefined}
                        />
                    </div>
                </div>
            </MaterialTooltip>
            {selected && (
                <Icon
                    fontSize="large"
                    style={{ color: "#8BC34A", position: "relative", top: "-190px", left: "165px", fontSize: "40px" }}
                >
                    check_circle
                </Icon>
            )}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "14px",
                    wordWrap: "break-word",
                    width: "200px",
                    textAlign: "center",
                }}
            >
                <span style={disabled ? { color: "#888" } : undefined}>{title}</span>
            </div>
        </div>
    );
};

export default ExportDestinationSquare;
